<template>
  <div
    v-if="getCurrentProcessType"
    :class="['DetailGrid__sidebar', { 'process-sidebar': !isAmsterdamRealisation }]"
  >
    <b-tabs>
      <b-tab>
        <template #title>
          <i class="icon fa-fw fal fa-circle-info" />
          {{ $t('processes.sidebar.features') }}
        </template>
        <ProcessSidebarMainTab
          :uuid="uuid"
          :record="record"
          :disabled="disabled"
        />
      </b-tab>

      <b-tab v-if="showTagsTab">
        <template #title>
          <i class="icon fa-fw fal fa-tag" />
          {{ $t('processes.sidebar.tags') }}
        </template>
        <RealisationSidebarTagsTab :record="record" />
      </b-tab>

      <b-tab v-if="canAccessEventLog">
        <template #title>
          <i class="icon fa-fw fal fa-calendar-clock" />
          {{ $t('processes.sidebar.events') }}
        </template>
        <RealisationSideBarEventsTab :record="record" />
      </b-tab>

      <b-tab @click="mailNotification = false">
        <template #title>
          <i class="icon fa-fw fal fa-envelope" />
          {{ $t('processes.sidebar.emails') }}
          <span
            v-if="mailNotification"
            class="mail-notification-dot"
          />
        </template>
        <RealisationSidebarMailTab :uuid="uuid" />
      </b-tab>
      <b-tab v-if="!isNewProcess && isPrivate && !isRvb">
        <template #title>
          <i class="fa-light fa-user" />
          {{ $t('processes.sidebar.contacts') }}
        </template>
        <RealisationSidebarContactsTab
          :record="record"
          :disabled="disabled"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProcessSidebarMainTab from '@/components/realisation/ProcessSidebarMainTab.vue';
import RealisationSidebarTagsTab from '@/components/realisation/RealisationSidebarTagsTab.vue';
import RealisationSidebarMailTab from '@/components/realisation/RealisationSidebarMailTab.vue';
import RealisationSideBarEventsTab from '@/components/realisation/RealisationSidebarEventsTab.vue';
import RealisationSidebarContactsTab from '@/components/realisation/RealisationSidebarContactsTab.vue';
import { mapGetters, mapActions } from 'vuex';
import Pusher from 'pusher-js';

export default {
  name: 'ProcessSidebar',
  components: {
    ProcessSidebarMainTab,
    RealisationSidebarTagsTab,
    RealisationSidebarMailTab,
    RealisationSideBarEventsTab,
    RealisationSidebarContactsTab
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pusher: null,
      pusherChannel: null,
      mailNotification: false,
    };
  },
  computed: {
    ...mapGetters('realisations', ['getSelectedRecord']),
    ...mapGetters('processes', ['getSelectedProcess', 'getCurrentProcessType']),
    ...mapGetters('tenant', ['getActiveProcessTypes']),
    ...mapGetters('user', ['canAccessEventLog', 'canAccessDebugger']),
    ...mapGetters('tenant', ['getEnabledTags']),
    selectedProcessType() {
      return this.getActiveProcessTypes.find(type => type.value === 'realisation');
    },
    record() {
      return this.getSelectedRecord || this.getSelectedProcess || { processType: this.selectedProcessType };
    },
    isRvb () {
      return process.env.VUE_APP_TENANT === 'rvb'
    },
    isPrivate () {
      return this.record.processType.value === 'private'
    },
    showTagsTab() {
      return this.record.ref && (this.getEnabledTags.length || this.record.hasTags());
    },
    isNewProcess () {
      return this.$route.name.toLowerCase().includes('new')
    },
    isAmsterdamRealisation () {
      return process.env.VUE_APP_TENANT === 'amsterdam' &&
             (this.record.processType.value === 'realisation' || this.isNewProcess)
    }
  },
  watch: {
    uuid(newUUID, oldUUID) {
      if (newUUID === oldUUID) return;
      this.unsubscribePusher();
      this.subscribePusher(newUUID);
    }
  },
  mounted() {
    if (!this.uuid) return;
    this.loadMailLogs({ processUUID: this.uuid });
    this.subscribePusher(this.uuid);
  },
  beforeDestroy() {
    this.unsubscribePusher();
  },
  methods: {
    ...mapActions('mail', ['loadMailLogs']),
    subscribePusher(uuid) {
      this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER,
      });
      this.pusherChannel = this.pusher.subscribe(`process-${uuid}`);
      this.pusherChannel.bind('delivery-status', ({ messageID, deliveryStatus }) => {
        const known = this.$store.getters['mail/getMails'].some(m => m.messageID === messageID);
        if (known) {
          this.$store.commit('mail/updateMailDeliveryStatus', { messageID, deliveryStatus });
        } else {
          this.loadMailLogs({ processUUID: uuid });
          this.mailNotification = true;
        }
      });
    },
    unsubscribePusher() {
      if (this.pusherChannel) {
        this.pusherChannel.unbind_all();
        this.pusher.unsubscribe(`process-${this.uuid}`);
      }
      if (this.pusher) {
        this.pusher.disconnect();
        this.pusher = null;
        this.pusherChannel = null;
      }
    },
  }
};
</script>

<style scoped>
.mail-notification-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #007bff;
  margin-left: 4px;
  vertical-align: middle;
}
</style>
